import { useCallback, useRef } from 'react';
import {
    ARCHIPRO_IMPRESSION_TRACKER,
    useTracker,
    type LogImpressionProps,
} from '@archipro-website/tracker';

/**
 * An impression logged when the caller says the item was seen, rather than
 * when it scrolls into view: for a name whose content only shows on hover.
 * Sent once per mount, through the same pipeline as `useLogImpression`.
 */
export const useLogImpressionOnDemand = ({
    type,
    itemID,
    professionalID,
}: LogImpressionProps) => {
    const tracker = useTracker();
    const logged = useRef(false);

    return useCallback(() => {
        if (logged.current || itemID <= 0 || professionalID <= 0) return;
        logged.current = true;
        void tracker.log('Impression', {
            url: new URL(window.location.href),
            data: { ID: itemID, type, ProfessionalID: professionalID },
            targetTracker: ARCHIPRO_IMPRESSION_TRACKER,
        });
    }, [tracker, type, itemID, professionalID]);
};
